import * as React from "react";
import useD365Form from "../../../hooks/d365-form/use-d365-form";
import { useStaticQuery, graphql } from "gatsby";

function EmailForm(params) {
  const { site } = useStaticQuery(query);
  const isOEE = site.siteMetadata.vorneDomain === "https://www.oee.com";
  const formId =
    params.formId ??
    (isOEE
      ? "2a68a713-d820-ee11-9cbd-0022482b281a"
      : "273dca1f-d820-ee11-9cbd-0022482b281a");
  const websiteId = isOEE
    ? "PnT9Zh45RLmtv6vAE84FnuUNhFe_0aGcAECRWc1l99Y"
    : "pzmq4nDU89h4txWoGGwugz5IMbVhmxLl-B9MlmdtOqs";
  const hostName = "2a768ee8dd2f4342b33eafb283a2318a.svc.dynamics.com";

  const { isRendered } = useD365Form({ formId, onSubmit: params.onSubmit });

  return (
    <div style={{ display: isRendered ? "block" : "none" }}>
      <div data-form-block-id={formId} />
      <div
        id={
          isOEE
            ? "dPnT9Zh45RLmtv6vAE84FnuUNhFe_0aGcAECRWc1l99Y"
            : "dpzmq4nDU89h4txWoGGwugz5IMbVhmxLl-B9MlmdtOqs"
        }
      />
      <div
        className="d365-mkt-config"
        style={{ display: "none" }}
        data-website-id={websiteId}
        data-hostname={hostName}
      />
    </div>
  );
}

const query = graphql`
  query {
    site {
      siteMetadata {
        titleBase
        leadSource
        contactSource
        vorneDomain
      }
    }
  }
`;

export default EmailForm;
